if (!customElements.get('rj-table-finder')) {
  customElements.define('rj-table-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', () => this.filter());
      this.filter();
    }
    filter() {
      const kind = this.querySelector('select[data-kind]').value;
      const shape = this.querySelector('select[data-shape]').value;
      const material = this.querySelector('select[data-material]').value;
      let visible = 0;
      this.querySelectorAll('article[data-kind]').forEach(card => {
        card.hidden = !((shape === 'all' || card.dataset.shape === shape) && (kind === 'all' || card.dataset.kind === kind) && (material === 'all' || card.dataset.material === material));
        if (!card.hidden) visible++;
      });
      this.querySelector('[data-finder-status]').textContent = visible ? `${visible} ${visible === 1 ? 'bord matcher' : 'borde matcher'} dine valg. Kontrollér størrelse og tilgængelighed på produktsiden.` : 'Ingen borde matcher lige nu. Vælg et andet materiale eller kontakt os for rådgivning.';
    }
  });
}
